import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.14 2.16 6.68 7.62H5.27l5.46-5.46ZM12 12.5a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1ZM17 0a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9a2.79 2.79 0 0 1 .71-1.71L7.29.71A2.79 2.79 0 0 1 9 0ZM1 17h16V9.5H1Zm.12-8.5H17V1H9a1.85 1.85 0 0 0-1 .41L1.41 8a1.78 1.78 0 0 0-.29.5Zm12.61-6.34h1.41L9.68 7.62H8.27Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "carrosserie"}) } }